import logo from '../../assets/images/2.webp'
import navLogo from '../../assets/images/logo.webp'
import cardBg from '../../assets/images/cardbg.svg'




export default function SalPageLayout({ children }) {

    return (


        <>
               <div className="min-h-[100vh] h-max pb-20 bg-cover" style={{ backgroundImage: `url(${navLogo})` }}>
        <div className="container space-y-5 h-full pt-5">
          <div className="grid gap-5 w-full">
            {children}
          </div>
        </div>
      </div>
  );
        </>
    )

}